import { render, staticRenderFns } from "./MyRewards.vue?vue&type=template&id=0b6c2322&scoped=true"
import script from "./MyRewards.vue?vue&type=script&lang=js"
export * from "./MyRewards.vue?vue&type=script&lang=js"
import style0 from "./MyRewards.vue?vue&type=style&index=0&id=0b6c2322&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6c2322",
  null
  
)

export default component.exports